import { Tag } from '@cmpsr/components';

type TestBadgeProps = {
  value: number;
};

export default function TestBadge({ value }: TestBadgeProps) {
  const numericValue = value * 100;
  const displayValue = Math.round(numericValue * 100) / 100;

  return (
    <Tag
      mx={{ base: '0', md: 'auto' }}
      p="spacer-2"
      size="l"
      w="fit-content"
      bgColor="primary-default"
      border="0"
      h="fit-content"
      _hover={{ bgColor: 'primary-default' }}
    >
      <Tag.Label color="text-link-accent-default">{displayValue}%</Tag.Label>
    </Tag>
  );
}
